var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewEmptyProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0001 16.9998C20.1309 16.9998 22.6667 14.464 22.6667 11.3332C22.6667 8.20234 20.1309 5.6665 17.0001 5.6665C13.8692 5.6665 11.3334 8.20234 11.3334 11.3332C11.3334 14.464 13.8692 16.9998 17.0001 16.9998ZM17.0001 19.8332C13.2176 19.8332 5.66675 21.7315 5.66675 25.4998V28.3332H28.3334V25.4998C28.3334 21.7315 20.7826 19.8332 17.0001 19.8332Z",
    fill: "#00456F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewEmptyProfile);
export default __webpack_public_path__ + "static/media/new_empty_profile.dbab5a629743e19d31cd76796bab251a.svg";
export { ForwardRef as ReactComponent };